<template>
	<div>
		<!-- 옵션 -->
		<div class="section">
			<b-collapse class="panel" :open="false" aria-id="collapseEditComponentOption">
				<div
					slot="trigger"
					class="panel-heading"
					role="button"
					aria-controls="collapseEditComponentOption">
					<b-field custom-class="is-medium">
						<template slot="label">
							<span class="has-text-primary">{{title!==''?title:'컴포넌트 옵션'}}</span>
							<b-tooltip v-if="message" type="is-dark" :label="message!==''?message:''">
								<b-icon size="is-small" icon="help-circle-outline"></b-icon>
							</b-tooltip>
						</template>
					</b-field>
				</div>
				<div class="panelBoxWrap is-bright">
					<div class="content">
						<div class="level">
							<div class="level-left"></div>
							<div class="level-right">
								<b-button @click="modal='componentOption'" icon-left="plus">추가</b-button>
							</div>
						</div>
						<div class="columns is-multiline">
							<div class="column is-one-quarter optionItemCell" v-for="(optionItem, idx) in option" :key = "'option'+idx">
								<!-- 타이틀 -->
								<h4 class="title is-6">{{optionItem.name}}
									<div class="buttons btnsWrap">
										<b-tooltip type="is-dark" label="수정">
											<b-button class="btnEditItem" size="is-small" icon-right="pencil" @click="optionEdit(idx)"></b-button>
										</b-tooltip>
										<b-tooltip type="is-dark" label="삭제">
											<b-button class="btnDeleteItem" size="is-small" icon-right="close" @click="optionDelete(idx)"></b-button>
										</b-tooltip>
									</div>
								</h4>

								<!-- 옵션 항목 -->
								<!-- 문자열 -->
								<b-field v-if="optionItem.type==='string'" :message="optionItem.desc">
									<b-input :key="'optionInputViewString'+idx" @input="optionItem.value=$event" :value="optionItem.value?optionItem.value:''"></b-input>
								</b-field>
								<!-- 숫자 -->
								<b-field v-else-if="optionItem.type==='number'" :message="optionItem.desc">
									<b-input :key="'optionInputViewNumber'+idx" type="number" :max="optionItem.max" :min="optionItem.min" @input.native="optionItem.value=$event.target.value" :value="optionItem.value?optionItem.value:0"></b-input>
								</b-field>
								<!-- Boolean -->
								<b-field v-else-if="optionItem.type==='boolean'" :message="optionItem.desc">
									<b-switch
										size="is-medium"
										:key="'optionInputViewBolean'+idx"
										true-value="true"
										false-value="false"
										:value="optionItem.value?optionItem.value:false"
										@input.native="optionSwitchHandler($event, optionItem.name)">
										<span v-html="optionItem.value"></span>
									</b-switch>
								</b-field>
								<div v-else>
									optionItem.value?optionItem.value:''
								</div>
							</div>
						</div>
					</div>
				</div>
			</b-collapse>
		</div>

		<!-- 옵션 추가/수정 모달 -->
		<b-modal :active="modal==='componentOption'?true:false" @close="modal=''">
			<div class="modal-card" style="width: auto">
				<header class="modal-card-head">
					<p class="modal-card-title">옵션 추가</p>
				</header>
				<section class="modal-card-body">
					<div class="columns">
						<div class="column">
							<b-field label="Key">
								<b-input :value="optionModalData.name" @input="optionModalData.name = $event" />
							</b-field>
						</div>
						<div class="column">
							<b-field label="Type">
								<b-select v-model="optionModalData.type" @input="optionTypeChanged" :value="optionModalData.type?'optionModalData.type':optionModalData.type='string'" placeholder="Select a type">
									<option
										v-for="(option, idx) in optionType"
										:value="option"
										:key="'optionList'+idx">
										{{ option }}
									</option>
								</b-select>
							</b-field>
						</div>
						<div class="column">
							<b-field label="Default Value">
								<!-- 숫자 -->
								<template v-if="optionModalData.type==='number'">
									<b-input key='optionInputNumber' type="number" :value="optionModalData.value" @input="optionModalData.value = $event" />
								</template>
								<b-switch
									key='optionInputBoolean'
									v-else-if="optionModalData.type==='boolean'"
									size="is-medium"
									true-value="true"
									false-value="false"
									:value="optionModalData.value"
									@input.native="switchChanged($event, 'optionModalData')">
									<span v-html="optionModalData.value"></span>
								</b-switch>
								<b-input key='optionInputString' v-else :value="optionModalData.value" @input="optionModalData.value = $event" />
							</b-field>
						</div>
						<div class="column" v-if="optionModalData.type==='number'">
							<b-field label="Max">
								<b-input key='optionInputMax' type="number" :value="optionModalData.max" @input="optionModalData.max = $event" />
							</b-field>
						</div>
						<div class="column" v-if="optionModalData.type==='number'">
							<b-field label="Min">
								<b-input key='optionInputMin' type="number" :value="optionModalData.min" @input="optionModalData.min = $event" />
							</b-field>
						</div>
					</div>
					<div class="columns">
						<div class="column">
							<b-field label="Description (설명)">
								<b-input key='optionInputDescription' :value="optionModalData.desc" @input="optionModalData.desc = $event" />
							</b-field>
						</div>
					</div>
				</section>
				<footer class="modal-card-foot">
					<div class="container">
						<button v-if="optionModalDataEdit" class="button" type="button" @click="editOption">확인</button>
						<button v-else class="button" type="button" @click="addNewOption">확인</button>
					</div>
				</footer>
			</div>
		</b-modal>
	</div>
</template>

<script>
export default {
	name: 'OptionEditor',
	props: {
		componentName: {
			type: String,
			default: 'OptionEditor'
		},
		tag: {
			type: String,
			default: 'p'
		},
		title: {
			type: String,
			default: ''
		},
		message: {
			type: String,
			default: ''
		},
		id: {
			type: String,
			default: null
		},
		option: {
			type: Array,
			default: function () {
				return []
			}
		}
	},
	data () {
		return {
			modal: '',
			optionType: ['string', 'number', 'boolean'],
			optionModalDataEdit: false,
			optionModalDataEditIdx: 0,
			optionModalData: []
		}
	},
	computed: {},
	methods: {
		optionTypeChanged (e) {
			// console.log('option type changed', e)
			var obj = this.optionModalData
			if (!obj) return
			if (obj.type === 'string') {
				obj.value = ''
			} else if (obj.type === 'number') {
				obj.value = 0
			} else {
				obj.value = false
			}
			this.optionModalData = []
			this.optionModalData = obj
		},
		addNewOption (e) {
			var data = {}
			if (this.optionModalData.name) {
				data = {
					name: this.optionModalData.name,
					type: this.optionModalData.type,
					value: this.optionModalData.value,
					desc: this.optionModalData.desc
				}
				if (this.optionModalData.type === 'number') {
					if (this.optionModalData.max !== undefined && this.optionModalData.max !== null) {
						data.max = this.optionModalData.max
					}
					if (this.optionModalData.min !== undefined && this.optionModalData.min !== null) {
						data.min = this.optionModalData.min
					}
				}
				this.option.push(data)
				this.$buefy.toast.open('옵션 항목이 저장되었습니다. 페이지를 저장하면 서버에 반영됩니다.')
			}
			this.optionModalData = {}
			this.modal = ''
		},
		editOption (e) {
			var data = {}
			if (this.optionModalData.name) {
				data = {
					name: this.optionModalData.name,
					type: this.optionModalData.type,
					value: this.optionModalData.value,
					desc: this.optionModalData.desc
				}
				if (this.optionModalData.type === 'number') {
					if (this.optionModalData.max !== undefined && this.optionModalData.max !== null) {
						data.max = this.optionModalData.max
					}
					if (this.optionModalData.min !== undefined && this.optionModalData.min !== null) {
						data.min = this.optionModalData.min
					}
				}
				this.$set(this.option, this.optionModalDataEditIdx, data)
				this.$buefy.toast.open('옵션 항목이 변경이 완료 되었습니다. 페이지를 저장하면 서버에 반영됩니다.')
			}
			this.optionModalData = {}
			this.optionModalDataEdit = false
			this.modal = ''
		},
		optionDelete (idx) {
			if (this.option[idx].name) {
				this.$buefy.dialog.confirm(
					{
						message: '삭제하시겠습니까?',
						onConfirm: () => {
							console.log('옵션 삭제')
							this.option.splice(idx, 1)
							this.$buefy.toast.open('옵션 항목이 삭제되었습니다. 페이지를 저장하면 서버에 반영됩니다.')
						}
					})
			}
		},
		optionEdit (idx) {
			if (this.option[idx].name) {
				this.$buefy.dialog.confirm(
					{
						message: '수정하시겠습니까?',
						onConfirm: () => {
							console.log('옵션 수정')
							this.optionModalDataEdit = true
							this.optionModalDataEditIdx = idx
							this.optionModalData = this.option[idx]
							this.modal = 'componentOption'
						}
					})
			}
		},
		switchChanged (e, tgObj) {
			var temp = {}
			for (var item in this[tgObj]) {
				temp[item] = this[tgObj][item]
			}
			temp.value = e.target.checked
			this[tgObj] = temp
		},
		optionSwitchHandler (e, name) {
			var idx = this.optionGetIndex(this.option, name)
			if (this.option[idx].name) {
				this.option[idx].value = e.target.checked
			}
		},
		optionGetIndex (obj, name) {
			var tgArray = []
			for (var arrItem in obj) {
				tgArray.push(obj[arrItem])
			}
			var result = tgArray.findIndex(function (opt) {
				return opt.name === name
			})
			return result
		}
	}
}
</script>

<style lang="scss"> // scoped
@import '@/css/variables.scss';
.section {
	padding: 5px 0;
	.panelBoxWrap {
		position: relative;
		border-radius: 4px;
		padding: 2rem;
		background-color: #f9f9f9;
		color: #a8a8a8;
	}
}
.optionItemCell {
	position: relative;
	background-color: #fff;
	border: 1px solid rgb(226, 226, 226);
	.title {
		color: $c-gray-dark;
		.btnsWrap {
			position: absolute;
			top: 5px; right: 5px;
		}
	}
}

/*
	##Device = Laptops, Desktops
	##Screen = B/w 1025px to 1280px
*/
@media (min-width: 1025px) and (max-width: 1280px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (portrait)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	//CSS
}

/*
	##Device = Tablets, Ipads (landscape)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  //CSS
}

/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/
@media (min-width: 650px) and (max-width: 767px) {
	//css
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	//CSS
}
</style>
